import { get } from 'lodash-es'

import { Select } from '@loadsmart/loadsmart-ui'
import { Field } from '@loadsmart/miranda-react'

import { type Option } from 'core/domain/Option'

import { type FilterEntrypoint, type FilterKey } from '../ShipmentsMetadata'

const FILTER_OPTIONS: Array<Option> = [
  { label: 'Pending appointments', value: 'pendingAppointments' },
  { label: 'Missing pods', value: 'missingPods' },
  { label: 'Missing invoices', value: 'missingInvoices' },
]

type ShipmentsMetadataMobileViewProps = {
  selectedFilter: FilterKey | undefined
  onFilterClick: (filterKey?: FilterKey, entrypoint?: FilterEntrypoint) => void
}

export function ShipmentsMetadataMobileView({
  selectedFilter,
  onFilterClick,
}: ShipmentsMetadataMobileViewProps) {
  return (
    <Field>
      <Field.Label id="shipments-metadata-label">Saved filters </Field.Label>
      <Select
        name="shipments-metadata"
        placeholder="Saved filters"
        value={FILTER_OPTIONS.find(option => option.value === selectedFilter)}
        onChange={event => {
          const value = get(event, 'target.value.value')
          onFilterClick(value, 'savedFiltersDropdown')
        }}
        options={FILTER_OPTIONS}
      />
    </Field>
  )
}
